export interface ITableOrder {
  option: string;
  align: "left" | "right" | "inherit" | "center" | "justify" | undefined;
  id: string;
  show: { mobile: boolean; desktop: boolean };
}

export const ITableOrderTitles: ITableOrder[] = [
  // Desktop only
  {
    option: "",
    align: "center",
    id: "downloadNf",
    show: { mobile: false, desktop: true },
  },

  // Comuns aos prints (aparecem nas duas)
  {
    option: "Pedido",
    align: "left",
    id: "orderNumber",
    show: { mobile: true, desktop: true },
  },
  {
    option: "Data da Entrega",
    align: "left",
    id: "deliveryDate",
    show: { mobile: true, desktop: true },
  },

  // Mobile only: botão/coluna do Pix
  {
    option: "",
    align: "center",
    id: "arrowDetailsMobile",
    show: { mobile: true, desktop: false },
  },
  {
    option: "",
    align: "center",
    id: "pixMobile",
    show: { mobile: true, desktop: false },
  },
  {
    option: "",
    align: "center",
    id: "trashMobile",
    show: { mobile: true, desktop: false },
  },

  // Demais colunas (desktop)
  {
    option: "Filial",
    align: "center",
    id: "filial",
    show: { mobile: false, desktop: true },
  },
  {
    option: "Razão social",
    align: "left",
    id: "companyName",
    show: { mobile: false, desktop: true },
  },
  {
    option: "Produto",
    align: "left",
    id: "product",
    show: { mobile: false, desktop: true },
  },
  {
    option: "Quantidade",
    align: "right",
    id: "quantity",
    show: { mobile: false, desktop: true },
  },
  {
    option: "Valor unitário",
    align: "right",
    id: "unitaryValue",
    show: { mobile: false, desktop: true },
  },
  {
    option: "Valor total",
    align: "right",
    id: "totalValue",
    show: { mobile: false, desktop: true },
  },
  {
    option: "Condição de pagamento",
    align: "center",
    id: "payment",
    show: { mobile: false, desktop: true },
  },
  {
    option: "Frete",
    align: "center",
    id: "freightType",
    show: { mobile: false, desktop: true },
  },
  {
    option: "Status Financeiro",
    align: "center",
    id: "financialStatus",
    show: { mobile: false, desktop: true },
  },
  {
    option: "Status do Pedido",
    align: "center",
    id: "orderStatus",
    show: { mobile: false, desktop: true },
  },

  // Ações (desktop)
  {
    option: "",
    align: "center",
    id: "rowActions",
    show: { mobile: false, desktop: false },
  },

  // Agenda (desktop)
  {
    option: "",
    align: "center",
    id: "calendarUpdateDelivery",
    show: { mobile: false, desktop: true },
  },
];
